import React, { useState } from 'react';

import classNames from 'classnames';
import { SectionTilesProps } from '../screens/Landing/utils/SectionProps';
import SectionHeader from '../screens/Landing/components/sections/partials/SectionHeader';
import { GREEN, GREEN_OP_2, PRIMARY_COLOR_1, PRIMARY_COLOR_4, PRIMARY_COLOR_6, RED, WHITE } from '../appearance/Colors';

import { useMediaQuery } from 'react-responsive';
import customAnalytics from '../util/custom-analytics';
import SAVED_TYPE from '../util/saved-from-enum';
import Logo from './Landing/components/layout/partials/Logo';
import gpBadge from '../assets/google-badge.png';

const propTypes = {
    ...SectionTilesProps.types
};

const defaultProps = {
    ...SectionTilesProps.defaults
};

const Mobile = ({
    className,
    topOuterDivider,
    bottomOuterDivider,
    topDivider,
    bottomDivider,
    hasBgColor,
    invertColor,
    pushLeft,
    history,
    staticContext,
    ...props
}) => {
    const outerClasses = classNames(
        'testimonial section',
        topOuterDivider && 'has-top-divider',
        bottomOuterDivider && 'has-bottom-divider',
        hasBgColor && 'has-bg-color',
        invertColor && 'invert-color',
        className
    );

    const innerClasses = classNames(
        'testimonial-inner section-inner',
        topDivider && 'has-top-divider',
        bottomDivider && 'has-bottom-divider'
    );

    const tilesClasses = classNames('tiles-wrap', pushLeft && 'push-left');

    let referralIdLocal = localStorage.getItem('referralId');

    const [copiedToClipboard, setCopiedToClipboard] = useState(false);

    const htmlObject = () => {
        return (
            <div style={{ marginBottom: -32 }}>
                <p>Download the app and input the referral code during account registration to receive a bonus.</p>
                <p
                    onClick={() => copyToClip()}
                    className="m-0 container-xs ml-auto mr-auto mt-32 fw-600"
                    style={{
                        color: GREEN,
                        backgroundColor: copiedToClipboard ? GREEN_OP_2 : PRIMARY_COLOR_1,
                        // borderColor: ,
                        border: `1px solid ${PRIMARY_COLOR_6}`,
                        borderRadius: 10,
                        padding: 16
                    }}>
                    {referralIdLocal}
                </p>
                <p style={{ fontSize: 16, color: PRIMARY_COLOR_4, marginTop: 8 }}>
                    {copiedToClipboard ? "Copied!" : "Tap to copy"}
                </p>
            </div>
        )
    }

    const copyToClip = async () => {
        navigator.clipboard
            .writeText(referralIdLocal)
            .then(() => {
                setCopiedToClipboard(true);
                setTimeout(() => {
                    setCopiedToClipboard(false);
                }, 1500);
                customAnalytics.message_action({
                    "action": "Copy",
                    "type": "Referral"
                })
            })
            .catch(() => {
                alert("Something went wrong, please copy the code manually");
            });

    }

    const sectionHeader = {
        title: referralIdLocal ? "You've got an invite!" : 'Download Luckynote',
        paragraph: referralIdLocal ? htmlObject() : 'Get your personal messenger on all your devices'
    };

    const platforms = [
        {
            name: 'iPhone & iPad',
            description: 'Capture thoughts on the go with our native iOS app.',
            link: 'https://apps.apple.com/us/app/luckynote-message-yourself/id1566320984',
            analytics: SAVED_TYPE.IOS,
            badge: require('../assets/ios-badge.png')
        },
        {
            name: 'Android',
            description: 'Full-featured Android app with seamless sharing between apps.',
            link: 'https://play.google.com/store/apps/details?id=com.luckynote',
            analytics: SAVED_TYPE.ANDROID,
            badge: gpBadge
        }
    ];

    const isMobile = useMediaQuery({ maxWidth: 767 });

    return (
        <div style={{ display: 'flex', flexDirection: 'column' }} >
            <div
                style={{ margin: 16, position: 'absolute', top: 0, left: 0, background: WHITE }}
                onClick={() => {
                    history.push('/home');
                }}
            >
                <Logo />
            </div>
            <section {...props} className={outerClasses} id="download-mobile" style={{ marginTop: 100 }}>
                <div className="container">
                    <div className={innerClasses}>
                        <SectionHeader data={sectionHeader} className="center-content" tag="h1" />
                        
                        {/* Platform Cards */}
                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)',
                            gap: '24px',
                            marginTop: '32px',
                            maxWidth: '800px',
                            margin: '32px auto 0'
                        }}>
                            {platforms.map((platform, index) => (
                                <div
                                    key={index}
                                    className="platform-card"
                                    style={{
                                        backgroundColor: WHITE,
                                        borderRadius: '16px',
                                        padding: '24px 24px',
                                        border: '1px solid #e9ecef',
                                        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                        cursor: 'pointer',
                                        textAlign: 'center',
                                        position: 'relative',
                                        overflow: 'hidden'
                                    }}
                                    onClick={() => {
                                        customAnalytics.mobile_download(platform.analytics);
                                        window.open(platform.link, '_blank');
                                    }}
                                    onMouseOver={(e) => {
                                        e.currentTarget.style.transform = 'translateY(-8px)';
                                        e.currentTarget.style.boxShadow = '0 20px 40px rgba(0,0,0,0.12)';
                                    }}
                                    onMouseOut={(e) => {
                                        e.currentTarget.style.transform = 'translateY(0)';
                                        e.currentTarget.style.boxShadow = 'none';
                                    }}
                                >
                                    {/* Platform name */}
                                    <h3 style={{
                                        margin: '0 0 16px',
                                        fontSize: '24px',
                                        fontWeight: '600',
                                        color: '#25282C'
                                    }}>
                                        {platform.name}
                                    </h3>

                                    {/* Description */}
                                    <p style={{
                                        margin: '0 0 20px',
                                        fontSize: '16px',
                                        lineHeight: '1.6',
                                        opacity: 0.8,
                                        color: '#495057'
                                    }}>
                                        {platform.description}
                                    </p>

                                    {/* Large app store badge */}
                                    <img
                                        src={platform.badge}
                                        alt={`Download ${platform.name}`}
                                        style={{
                                            height: '60px',
                                            objectFit: 'contain',
                                            margin: '0 auto'
                                        }}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

Mobile.propTypes = propTypes;
Mobile.defaultProps = defaultProps;

export default Mobile;
